import * as React from 'react';
import SliderPiece from "@layout/pieces/Slider";
import DescriptionPiece from "@layout/pieces/Description";
import UnorderedListPiece from "@layout/pieces/UnorderedList";
import SyntaxHighlighter from "@layout/pieces/Syntax-Highlighter";
import Table from "@layout/pieces/Table";
import Formula from "@layout/pieces/Formula";
import { Piece, PieceSlider, PieceDescription, PieceUnorderedList, PieceSyntaxHighlighter, PieceTable, PieceFormula } from '@store/index';

interface Props {
    pieces: Piece[];
}

const Pieces = ({ pieces }: Props) => (
    <>
        { 
            pieces.map((piece: Piece, index) => {
                switch (piece.type) {
                    case 'slider': {
                        return <SliderPiece key={`pieces-${index}`} piece={piece as PieceSlider}/>
                        break;
                    }
                    case 'description': {
                        return <DescriptionPiece key={`pieces-${index}`} piece={piece as PieceDescription}/>
                        break;
                    }
                    case 'unordered list': {
                        return <UnorderedListPiece key={`pieces-${index}`} piece={piece as PieceUnorderedList}/>
                        break;
                    }
                    case 'syntax highlighter': {
                        return <SyntaxHighlighter key={`pieces-${index}`} piece={piece as PieceSyntaxHighlighter}/>
                        break;
                    }
                    case 'table': {
                        return <Table key={`pieces-${index}`} piece={piece as PieceTable}/>
                        break;
                    }
                    case 'formula': {
                        return <Formula key={`pieces-${index}`} piece={piece as PieceFormula}/>
                        break;
                    }
                    default: {
                        return undefined;
                    }
                }
            })
        }
    </>
);

export default Pieces;


// WEBPACK FOOTER //
// ./src/components/layout/pieces/index.tsx